import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-flow-environment',
    templateUrl: './flow-environment.component.html',
    styleUrls: ['./flow-environment.component.css'],
    standalone: false
})
export class FlowEnvironmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
